import CommentList from './comment-list';

export default CommentList;
